export const ARROW_LAYERS_COUNT = 5


// WEBPACK FOOTER //
// ./components/UpgradeIcon/constants.jsx